module.exports = __webpack_public_path__ + "img/BRCA4_pDC.06984ec9.png";